import React from 'react'
import {Feed, Icon} from 'semantic-ui-react'
import TimeAgo from 'javascript-time-ago'

// Load locale-specific relative date/time formatting rules.
import nb from 'javascript-time-ago/locale/nb'

// Add locale-specific relative date/time formatting rules.
TimeAgo.locale(nb);

// Create relative date/time formatter.
const timeAgo = new TimeAgo('nb-NO');

const getData = entry => {
    switch (entry.type) {
        case 'PARTICIPANT_IS_NOT_ATTENDING':
            return {
                icon: 'remove user',
                text: entry.agentName + ' har meldt av ' + entry.subjectName,
                color: 'red'
            };
        case 'PLAYER_LONG_TERM_DEREGISTERED':
            return {
                icon: 'remove user',
                text: entry.subjectName + ' er langtidsavmeldt',
                color: 'red'
            };
        case 'PARTICIPANT_IS_ATTENDING':
            return {
                icon: 'add user',
                text: entry.agentName + ' har meldt på ' + entry.subjectName,
                color: 'green'
            };
        case 'GUEST_PARTICIPANT_ADDED':
            return {
                icon: 'add user',
                text: entry.agentName + ' har meldt på gjestespiller ' + entry.subjectName,
                color: 'green'
            };
        case 'GUEST_PARTICIPANT_NOT_ATTENDING':
            return {
                icon: 'remove user',
                text: entry.agentName + ' har meldt av gjestespiller ' + entry.subjectName,
                color: 'red'
            };
        case 'PARTICIPANT_NO_ANSWER':
            return {
                icon: 'remove user',
                text: entry.subjectName + ' svarte ikke på påmeldingskjemaet før treningsstart',
                color: 'red'
            };
        case 'TRAINING_IS_CANCELLED':
            return {
                icon: 'ban',
                text: entry.agentName + ' avlyste treningen',
                color: 'red'
            };
        case 'TRAINING_IS_RESCHEDULED':
            return {
                icon: 'play circle outline',
                text: entry.agentName + ' fjernet avlysningen',
                color: 'green'
            };
        case 'NOT_COUNTING_BEER_PUNISHMENTS':
            return {
                icon: 'magic',
                text: 'Ingen ølstraff for denne treningen',
                color: 'green'
            };
        default:
            return {
                icon: 'beer',
                text: "Ukjent feed entry"
            };
    }
};

const feedEvents = entries => {
    return entries.map(entry => {
        const data = getData(entry);
        return (
            <Feed.Event key={entry.time}>
                <Feed.Label>
                    <Icon name={data.icon} color={data.color}/>
                </Feed.Label>
                <Feed.Content>
                    <Feed.Summary>
                        {data.text}
                        <Feed.Date>{timeAgo.format(new Date(entry.time))}</Feed.Date>
                    </Feed.Summary>
                </Feed.Content>
            </Feed.Event>
        )
    });
};

const TrainingFeed = ({entries}) =>
    <Feed>
        {feedEvents(entries)}
    </Feed>;

export default TrainingFeed



// WEBPACK FOOTER //
// ./src/Components/TrainingFeed.js